import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Orders from "../../baker/screen/Orders";
import { useNavigate } from "react-router";
import OwnerDashboard from "./OwnerDashboard";
import ManagerDashboard from "./ManagerDashboard";
import POS from "../../order/screen/POS";
import { isKDSMode, isPOSMode } from "../../common/util";

export default function Dashboard(props) {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  console.log("ROLE", user.role);
  if (isPOSMode(user)) {
    return <POS />;
  } else if (isKDSMode(user)) {
    return <Navigate replace to="/production/tracker" />;
  } else if (user.role === "baker" || user.role === "owner") {
    return <OwnerDashboard />;
  } else if (user.role === "rep" || user.role === "manager") {
    return <ManagerDashboard />;
  } else if (user.role === "kitchen" || user.role === "kitchen leader") {
    return <Orders />;
  } else if (user.role === "clerk") {
    return <POS />;
  }
}
